// @ngInject
const config = ($stateProvider) => {
  $stateProvider.state('customer.users', {
    url: '/team',
    templateUrl: 'main/customer/users/users.tpl.html',
    controller: 'CustomerUsersController as vm',
  });
};

class CustomerUsersController {
  constructor($rootScope, customer) {
    'ngInject';
    $rootScope.pageTitle = `${customer.name || ''} - Team`;

    this.originalCustomer = customer;
  }
}

angular
  .module('main.customer.users', [])
  .config(config)
  .controller('CustomerUsersController', CustomerUsersController);
